/* ==========  Libs  ========== */
// import 'slick-carousel/slick/slick.js'

import 'jquery.maskedinput/src/jquery.maskedinput'

import 'bootstrap/js/dist/util'

// import 'bootstrap/js/dist/alert'

import 'bootstrap/js/dist/button'

// import 'bootstrap/js/dist/carousel'

import 'bootstrap/js/dist/collapse'

// import 'bootstrap/js/dist/dropdown'

import 'bootstrap/js/dist/modal'

// import 'bootstrap/js/dist/scrollspy'

// import 'bootstrap/js/dist/tab'

// import 'bootstrap/js/src/tooltip.js'
// import 'bootstrap/js/src/popover.js'
// import 'popper.js/dist/popper.js'
// import WOW from 'wow.js/dist/wow'
/* ==========  Custom scripts  ========== */
jQuery(document).ready(function ($) {
  // Кнопка меню
  $('.menu-toggle').on('click', function () {
    $('.menu-toggle').toggleClass('closeMenu')
    $(this).toggleClass('active showMenu')
    $('.main-nav').toggleClass('opacity nav--color fixed-top--mod-js')
    $('.phone__number').toggleClass('phone__number--color-js')
    $('.mode-operation').toggleClass('mode-operation--color-js')
    $('.btn-outline-primary').toggleClass('btn-outline-primary--color-js')
    $('.page').toggleClass('page-scroll')
  })
  // Фиксированная шапка
  $('.navbar-collapse a').on('click', function () {
    $('.main-nav__items').removeClass('showMenu')
    $('.menu-toggle').removeClass('closeMenu')
    $('.navbar-collapse').collapse('hide')
    $('.navbar-toggler')
      .removeClass('active')
      .addClass('collapsed')
    $('.main-nav').toggleClass('opacity .main-nav--color fixed-top--mod-js')
    $('.phone__number').toggleClass('phone__number--color-js')
    $('.mode-operation').toggleClass('mode-operation--color-js')
    $('.btn-outline-primary').toggleClass('btn-outline-primary--color-js')
    $('.page').toggleClass('page-scroll')
  })

  $(() => {
    // Функция прокрутки
    $(window).scroll(() => {
      var windowTop = $(window).scrollTop()
      windowTop > 730 ? $('.fixed-top').addClass('fixed-top--mod-js') : $('.fixed-top').removeClass('fixed-top--mod-js')
      // windowTop > 78 ? $('.phone__number').addClass('phone__number--color') : $('.phone__number').removeClass('phone__number--color')
      // windowTop > 78 ? $('.mode-operation').addClass('mode-operation--color') : $('.mode-operation').removeClass('mode-operation--color')
      // windowTop > 78 ? $('.btn-outline-primary').addClass('btn-outline-primary--color') : $('.btn-outline-primary').removeClass('btn-outline-primary--color')
    })
  })
  $('a[href*="#link-"]').on('click', function (e) {
    $('html,body').animate({
      scrollTop: $($(this).attr('href')).offset().top - 75
    }, 600)
    e.preventDefault()
  })
  jQuery(document).ready(function ($) {
    let myHash = location.hash // получаем значение хеша
    location.hash = '' // очищаем хеш
    if (myHash[1] != undefined) { // проверяем, есть ли в хеше какое-то значение
      $('html, body').animate(
        { scrollTop: $(myHash).offset().top - 75 }
        , 600) // скроллим за полсекунды
      location.hash = myHash // возвращаем хеш
    }
  })
  // Маска телефона
  $('#phone-1').mask('+7 (999) 999-99-99')
  $('#phone-2').mask('+7 (999) 999-99-99')
  $('#phone-3').mask('+7 (999) 999-99-99')
  // Формы
  $('form').submit(function () {
    var formID = $(this).attr('id') // Получение ID формы
    var formNm = $('#' + formID)
    $.ajax({
      type: 'POST',
      url: '/wp-content/themes/moscow-rockets/inc/mail.php', // Обработчик формы отправки
      data: formNm.serialize(),
      success: function (data) {
        // Вывод текста результата отправки в текущей форме
        $(formNm).html(data)
        setTimeout(function () {
          $('#phoneModal').modal('hide')
        }, 3000)
      }
    })
    return false
  })

  // Добавление 0
  // function pad(n) {
  //   if (n < 10)
  //     return '0' + n
  //   return n
  // }
  // Слайдер отзывы
  // $('.reviews__items').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: true,
  //   draggable: true,
  //   // mobileFirst: true,
  //   adaptiveHeight: true,
  //   // autoplay: true,
  //   // autoplaySpeed: 2000,
  //   speed: 500,
  //   fade: true,
  //   cssEase: 'linear',
  //   prevArrow: $('.reviews__prev'),
  //   nextArrow: $('.reviews__next')
  // })
  // let slickCount = $('.reviews__items')
  // $('.reviews__count').html(pad(slickCount.slick('getSlick').slideCount))

  // $('.reviews__items').on('afterChange', function (event, slick, currentSlide) {
  //   $('#reviews-count').text(pad(currentSlide + 1))
  // })
})
// Конец jQuery
